import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import 'dayjs/locale/it';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/ru';
import utc from 'dayjs/plugin/utc';

const userLng = sessionStorage.getItem('locale') || localStorage.getItem('locale');

dayjs.extend(utc);
dayjs.extend(localizedFormat).locale(userLng || 'en');
dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);

export default dayjs;
